import React, { useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import {
  FaDiscord,
  FaEnvelope,
  FaInfo,
  FaLinkedinIn,
  FaMailchimp,
  FaNotesMedical,
  FaStickyNote,
  FaUser,
} from "react-icons/fa";
import { BiInfoCircle } from "react-icons/bi"; // info icon
import Version from "./Version";
import VersionNotes from "./VersionNotes";

function Footer() {
  const [showNotes, setShowNotes] = useState(false);
  const handleClose = () => setShowNotes(false);
  const handleShow = () => setShowNotes(true);

  let date = new Date();
  let year = date.getFullYear();

  return (
    <>
      <Container fluid className="footer">
        <Row>
          <Col md="4" className="footer-copywright">
            <h3>Designed and Developed by Krishna Kasyap Kanuparthi</h3>
          </Col>
          <Col
            md="4"
            className="footer-copywright d-flex align-items-center justify-content-center"
          >
            <h3 className="me-2">
              Copyright © {year} <span>- <Version/></span>
            </h3>
          </Col>
          <Col md="4" className="footer-body">
            <ul className="footer-icons">
              <li className="social-icons" title="My Github">
                <a
                  href="https://github.com/kasyap2807"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons" title="My Linkdin">
                <a
                  href="http://www.linkedin.com/in/krishnakasyap"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons" title="My Discard">
                <a
                  href="https://discordapp.com/users/1197968138927620159"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons" title="My Mail">
                <a
                  href="https://mail.google.com/mail/u/0/?fs=1&to=kanuparthikasyap95@gmail.com&su=Subject&body=BodyText&tf=cm"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaEnvelope />
                </a>
              </li>
              <li className="social-icons" title="Admin Login">
                <a
                  href="/admin"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaUser />
                </a>
              </li>
              <li className="social-icons" title="Dev Notes">
                <a
                  href="https://kasyap.netlify.app/Dev_Notes.txt"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaStickyNote />
                </a>
              </li>
              <li className="social-icons iconss" title="Dev Updates">
                <p style={{ color: "white" }} onClick={handleShow}>
                  <FaInfo />
                </p>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* Modal for Update Notes */}
      <Modal show={showNotes} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Notes - <Version/></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VersionNotes/>
          <Modal.Title>Made With</Modal.Title>
          <ul>
            <li>🧑‍💻 React.Js</li>
            <li>🧑‍💻 Express Js</li>
            <li>🧑‍💻 Mongo DB</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Footer;
